// extracted by mini-css-extract-plugin
export default {"skillsbody":"skills_skillsbody__GPLP1","allicons":"skills_allicons__Gbqz3"};